import { useMediaQuery } from './use-media-query';

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

/**
 * Whether the visitor has asked for less motion.
 *
 * Subscribed, not sampled — see {@link useMediaQuery} for why that matters and for what the server
 * snapshot costs: anything gated on this starts in its moving state and settles on hydration, which is
 * the smaller surprise of the two.
 *
 * Only for the handful of places where the answer decides what is RENDERED (a still instead of a
 * player, a scroll loop that never starts). Anything that merely animates says so in CSS, with
 * `motion-reduce:` or a `prefers-reduced-motion` block in `-styles/theme.css`.
 */
export function usePrefersReducedMotion() {
	return useMediaQuery(REDUCED_MOTION);
}
